module.exports = __webpack_public_path__ + "img/2.965e5538.png";